import {
  web,
  frontend,
  design,
  backend,
  fullStack,
  cloud,
  html,
  css,
  javascript,
  reactjs,
  redux,
  mui,
  tailwind,
  scss,
  nodejs,
  expressjs,
  mongodb,
  mongoose,
  git,
  github,
  EC2,
  S3,
  vscode,
  python,
  odoo,
  ChatGPT,
  chrome,
  mongodbCompass,
  postman,
  ubuntu,
  Impress,
  jobit,
  yoga,
  mcp,
  rpc,
  order,
  carton,
  review1,
  review2,
  review3,
  review4,
} from "../assets";

const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "work",
    title: "Work",
  },
  {
    id: "blog",
    title: "Blog",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "Web Developer",
    icon: web,
  },
  {
    title: "React Developer",
    icon: frontend,
  },
  {
    title: "Odoo Developer",
    icon: backend,
  },
  {
    title: "Full Stack Developer",
    icon: fullStack,
  },
];

const tools = [
  { name: "VS Code", icon: vscode },
  {
    name: "ChatGPT",
    icon: ChatGPT,
  },
  {
    name: "Chrome",
    icon: chrome,
  },
  {
    name: "Impress",
    icon: Impress,
  },
  {
    name: "Postman",
    icon: postman,
  },
  {
    name: "Mongodb Compass",
    icon: mongodbCompass,
  },
  {
    name: "Ubuntu",
    icon: ubuntu,
  },
];

const technologies = [
  {
    name: "Python",
    icon: python,
  },
  {
    name: "HTML 5",
    icon: html,
  },
  {
    name: "CSS 3",
    icon: css,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
  },
  {
    name: "Odoo",
    icon: odoo,
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "Redux",
    icon: redux,
  },
  {
    name: "Matirial UI",
    icon: mui,
  },

  {
    name: "Scss",
    icon: scss,
  },
  {
    name: "Node JS",
    icon: nodejs,
  },
  {
    name: "Express JS",
    icon: expressjs,
  },
  {
    name: "MongoDB",
    icon: mongodb,
  },
  {
    name: "Mongoose",
    icon: mongoose,
  },
  {
    name: "Git",
    icon: git,
  },
  {
    name: "GitHup",
    icon: github,
  },
  {
    name: "EC2",
    icon: EC2,
  },
  {
    name: "S3",
    icon: S3,
  },
];

const experiences = [
  {
    title: "Python Developer",
    company_name: "GhepHang Shipping | ghephang.com",
    icon: backend,
    iconBg: "#383E56",
    date: "Jan 2022 - Jun 2022",
    points: [
      "Built API services for a mobile app using the Web2py Python framework.",
      "Developed a dynamic dashboard with AngularJS and Bootstrap.",
      "Maintained the system and fixed bugs to keep the platform stable.",
      "Worked with Python, Web2py, AngularJS, HTML, CSS, Ajax, and SQLite3.",
    ],
  },
  {
    title: "Full-time Odoo Developer",
    company_name: "BnK Solution | bnksolution.com",
    icon: backend,
    iconBg: "white",
    date: "Jun 2022 - Jan 2024",
    points: [
      "Developed and customized Odoo modules based on client requirements.",
      "Collaborated with project managers, business analysts, and clients to gather requirements.",
      "Designed and implemented new features, technical documentation, and test cases.",
      "Provided technical support, troubleshooting, training, and code reviews for interns.",
      "Built API integration for mobile apps by connecting FastAPI with Odoo.",
      "Worked with Odoo 14-17, Python, PostgreSQL, Owl JS, FastAPI, Firebase, OAuth2, HTML, and Odoo.SH.",
    ],
  },
  {
    title: "Remote Freelancer",
    company_name: "Upwork.com",
    icon: design,
    iconBg: "#383E56",
    date: "Jan 2024 - Present",
    points: [
      "Delivered Odoo customization, integration, and server maintenance for global clients.",
      "Built a shipping-rate comparison and booking module for a France client, including Boxtal integration and PDF label generation.",
      "Customized an Odoo POS module for a UK restaurant client to support table booking and reservation management.",
      "Implemented n8n workflow automation for India clients and synced form data into Odoo CRM.",
      "Worked with Python, Odoo 12-19, PostgreSQL, Owl JS, HTML, SCSS, Linux, and Nginx.",
    ],
  },
  {
    title: "Remote Full-time Odoo Developer",
    icon: cloud,
    iconBg: "black",
    date: "Apr 2024 - Jan 2026",
    points: [
      "Deeply customized core Odoo modules such as Accounting, Sales, Inventory, Stock, Purchase, and Website.",
      "Built dynamic reports, dashboards, and kanban views using QWeb and XLSX, including Excel import/export flows.",
      "Integrated third-party services such as e-signature tools, e-invoice, logistics, and B2B ordering platforms.",
      "Created a custom import for Sale Order data from a ~400k-line Excel file, reducing delivery effort by 50%.",
      "Handled Odoo upgrades and migrations across multiple versions while maintaining production stability.",
    ],
  }  
];

const testimonials = [
  {
    name: "Client review 1",
    image: review1,
  },
  {
    name: "Client review 2",
    image: review2,
  },
  {
    name: "Client review 3",
    image: review3,
  },
  {
    name: "Client review 4",
    image: review4,
  },
];

const projects = [
  {
    name: "Ordermentum Connector",
    description:
      "Ordermentum is a B2B ordering and payments platform. This Odoo 17 module integrates Ordermentum with Odoo sales, invoicing, delivery, and payment workflows.",
    tags: [
      {
        name: "Odoo",
        color: "blue-text-gradient",
      },
      {
        name: "Python",
        color: "green-text-gradient",
      },
      {
        name: "docker",
        color: "pink-text-gradient",
      },
      {
        name: "PostgreSQL",
        color: "blue-text-gradient",
      },
    ],
    image: order,
    source_code_link: "https://github.com/hungdannt/cs_ordermentum_connector",
    live_link: "",
  },
  {
    name: "Cartoncloud Connector",
    description:
      "Cartoncloud is a logistics and shipping platform. This Odoo 17 module integrates CartonCloud warehouse, inventory, inbound, and outbound workflows with Odoo.",
    tags: [
      {
        name: "Odoo",
        color: "blue-text-gradient",
      },
      {
        name: "Python",
        color: "green-text-gradient",
      },
      {
        name: "docker",
        color: "pink-text-gradient",
      },
      {
        name: "PostgreSQL",
        color: "blue-text-gradient",
      },
    ],
    image: carton,
    source_code_link: "https://github.com/hungdannt/cs_cartoncloud_connector",
    live_link: "",
  },
  {
    name: "Fast Odoo RPC",
    description:
      "A next-generation, modern async Python library for Odoo RPC with type safety, AI integration, and MCP protocol support",
    tags: [
      {
        name: "Python",
        color: "blue-text-gradient",
      },
      {
        name: "odoo",
        color: "green-text-gradient",
      },
      {
        name: "rpc",
        color: "pink-text-gradient",
      },
    ],
    image: rpc,
    live_link: "",
    source_code_link: "https://github.com/hungdannt/fast-odoo-rpc",
  },
  {
    name: "MCP Server for Odoo",
    description:
      "An MCP server implementation that integrates with Odoo ERP systems, enabling AI assistants to interact with Odoo data and functionality through the Model Context Protocol.",
    tags: [
      {
        name: "Python",
        color: "blue-text-gradient",
      },
      {
        name: "odoo",
        color: "green-text-gradient",
      },
      {
        name: "mcp",
        color: "pink-text-gradient",
      },
    ],
    image: mcp,
    live_link: "",
    source_code_link: "https://github.com/hungdannt/mcp-server-odoo",
  },
  {
    name: "AI Document Assistant",
    description:
      "A modern document analysis application for interactive AI conversations with PDF content. Built with Next.js 15, OpenAI, and Pinecone.",
    tags: [
      {
        name: "Next.js",
        color: "blue-text-gradient",
      },
      {
        name: "Node.js",
        color: "green-text-gradient",
      },
      {
        name: "Tailwind CSS",
        color: "pink-text-gradient",
      },
    ],
    image: jobit,
    source_code_link: "https://github.com/hungdannt/fullstack-ai-document-assistant",
    live_link: "",
  },
  {
    name: "Yoga Institute",
    description:
      "A MEVN Stack Web Application. Gave more than 180+ hours on this project. The project also includes admin panel along with CRUD Functionalities. Blogging System using Firebase.",
    tags: [
      {
        name: "VueJS",
        color: "blue-text-gradient",
      },
      {
        name: "NodeJS",
        color: "green-text-gradient",
      },
      {
        name: "mongoDB",
        color: "pink-text-gradient",
      },
      {
        name: "firebase",
        color: "pink-text-gradient",
      },
    ],
    image: yoga,
    source_code_link: "",
  },
];

const blogs = [
  {
    title: "How to integrate online payment VNPay, Stripe with Odoo 19",
    date: "12/2025",
    readTime: "60 min read",
    category: "Odoo Integration",
    tags: ["Odoo", "Python", "API"],
    link: "https://dev.to/dan_tran_2120/tich-hop-vnpay-stripe-trong-odoo-19-9de",
  },

];

export {
  navLinks,
  services,
  technologies,
  experiences,
  testimonials,
  projects,
  blogs,
  tools,
};
